import React from 'react';
import { connect } from 'react-redux';
import { AlTemplateAquaRow } from 'PatientCareCenter/Note/AL/Templates';
import styles from './Common.module.css';


class AlTemplateAqua extends React.Component {

    render() {
        if (this.props.activities.length > 0) {
            return (
                <div className={styles.section_wrapper}>
                    <div className={styles.header_row}>Aquatics (97113)</div>

                    {Object.keys(this.props.activities)
                        .map(key => {
                            const result = this.props.activities[key];
                            return (
                                <AlTemplateAquaRow key={result.XLTMPAQNO} id={result.XLTMPAQNO} />
                            )
                        })
                    }
                </div>
            );
        } else {
            return (<span />);
        }
    }
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;

    return {
        activities: state.entities.notes.MLTMPAQUATICS ?
            Object.keys(state.entities.notes.MLTMPAQUATICS)
                .filter(key => {
                    return (state.entities.notes.MLTMPAQUATICS[key].NoteId === noteId)
                })
                .sort((a, b) => state.entities.notes.MLTMPAQUATICS[a].XLTMPAQORDER - state.entities.notes.MLTMPAQUATICS[b].XLTMPAQORDER)
                .map(key => state.entities.notes.MLTMPAQUATICS[key]) : [],
    };
}

const connectedAlTemplateAqua = connect(mapStateToProps)(AlTemplateAqua);
export { connectedAlTemplateAqua as AlTemplateAqua };

